import React, { useMemo, useState } from "react";
import Form from 'react-bootstrap/Form';
import Dropdown from 'react-bootstrap/Dropdown';
import { useFilterDataContext } from "../Context/FilterDataContext";

const MultiSelectAll = React.memo(({ items, title, autocompleteWidth, onSwitchChange }) => {
    const { filteredData, setFilteredData } = useFilterDataContext();
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const itemsUniq = useMemo(() => items.filter((item, index, self) =>
        index === self.findIndex((t) => t.value === item.value)
    ), [items]);

    const handleCheckboxChange = (selectedItem, e) => {
        e.stopPropagation();
        setFilteredData(prevData => {
            const currentSelected = prevData[title + "Data"]?.[title] || [];
            const isItemSelected = currentSelected.some(item => item.value === selectedItem.value);

            const newSelected = isItemSelected
                ? currentSelected.filter(item => item.value !== selectedItem.value)
                : [...currentSelected, selectedItem];

            if (newSelected.length !== 2) {
                onSwitchChange(title);
            }

            return {
                ...prevData,
                [title + "Data"]: {
                    ...prevData[title + "Data"],
                    [title]: newSelected
                }
            };
        });
    };

    const handleSelectAll = (e) => {
        e.stopPropagation();
        setFilteredData(prevData => {
            const allSelected = itemsUniq.every(item =>
                prevData[title + "Data"]?.[title]?.some(selected => selected.value === item.value)
            );

            return {
                ...prevData,
                [title + "Data"]: {
                    ...prevData[title + "Data"],
                    [title]: allSelected ? [] : [...itemsUniq]
                }
            };
        });
    };

    const selectedItems = filteredData[title + "Data"]?.[title] || [];
    const isSelected = (value) => {
        return selectedItems.some(item => item.value === value);
    };

    const handleClearAll = (e) => {
        e.stopPropagation();
        setFilteredData(prevData => ({
            ...prevData,
            [title + "Data"]: {
                ...prevData[title + "Data"],
                [title]: []
            }
        }));
    };

    const filteredItems = useMemo(() => itemsUniq.filter(item =>
        item.label.toLowerCase().includes(searchTerm.toLowerCase())
    ), [itemsUniq, searchTerm]);

    return (
        <Dropdown
            show={isOpen}
            onToggle={(isOpen) => setIsOpen(isOpen)}
            style={{ width: autocompleteWidth || "200px" }}
        >
            <Dropdown.Toggle
                style={{
                    backgroundColor: '#824bb0',
                    borderColor: '#824bb0',
                    color: 'white'
                }} className="w-100 text-center">
                {selectedItems.length ? `${selectedItems.length} sélectionné(s)` : 'Sélectionner'}
            </Dropdown.Toggle>

            <Dropdown.Menu style={{ width: '100%', padding: 0 }}>
                <div style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column'
                }}>
                    {selectedItems.length > 0 && (
                        <div style={{
                            padding: '0.5rem',
                            borderBottom: '1px solid #ced4da',
                            backgroundColor: 'white',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}>
                            <div>
                                {selectedItems.map(item => (
                                    <span
                                        key={item.value}
                                        className="badge me-1 mb-1"
                                        style={{
                                            cursor: 'pointer',
                                            backgroundColor: '#824bb0'
                                        }}
                                        onClick={(e) => handleCheckboxChange(item, e)}
                                    >
                                        {item.label} ×
                                    </span>
                                ))}
                            </div>
                            <span
                                onClick={handleClearAll}
                                style={{
                                    cursor: 'pointer',
                                    color: '#824bb0',
                                    fontSize: '1.2rem',
                                    fontWeight: 'bold',
                                    padding: '0 0.5rem'
                                }}
                            >
                                ×
                            </span>
                        </div>
                    )}

                    <div style={{ padding: '0.5rem' }}>
                        <Form.Control
                            type="text"
                            placeholder="Rechercher..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            style={{ width: '100%' }}
                        />
                    </div>

                    <div style={{
                        overflowY: "auto",
                        maxHeight: "200px"
                    }}>
                        <div
                            className="d-flex align-items-center p-2 hover-bg-light"
                            style={{ cursor: "pointer" }}
                            onClick={handleSelectAll}
                        >
                            <Form.Check
                                type="checkbox"
                                checked={itemsUniq.every(item => selectedItems.some(selected => selected.value === item.value))}
                                onChange={() => {}}
                                label="Tout sélectionner"
                                className="w-100"
                            />
                        </div>
                        {filteredItems.map((option) => (
                            <div
                                key={option.value}
                                className="d-flex align-items-center p-2 hover-bg-light"
                                style={{
                                    cursor: "pointer",
                                    backgroundColor: isSelected(option.value) ? '#f3f0ff' : 'transparent'
                                }}
                                onClick={(e) => handleCheckboxChange(option, e)}
                            >
                                <Form.Check
                                    type="checkbox"
                                    checked={isSelected(option.value)}
                                    onChange={() => {}}
                                    label={option.label}
                                    className="w-100"
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </Dropdown.Menu>
        </Dropdown>
    );
});

export default MultiSelectAll;
